type AccessTokenGetter = () => Promise<string>

let accessTokenGetter: AccessTokenGetter | null = null

// Registered once by App with a wrapper around Auth0's getAccessTokenSilently, so code outside
// React (axios wrapper, thunks) can get a token that Auth0 refreshes when it nears expiry.
export const setAccessTokenGetter = (getter: AccessTokenGetter) => {
  accessTokenGetter = getter
}

export const getAccessToken = async (): Promise<string> => {
  if (!accessTokenGetter) {
    throw new Error('Access token getter has not been registered')
  }
  return accessTokenGetter()
}
